// import React from "react";
// import { Download, FileSpreadsheet, FileText, LayoutTemplate, Upload } from "lucide-react";
// import { motion } from "framer-motion";
// import PageHero from "../components/common/PageHero";
// import StatGrid from "../components/common/StatGrid";

// export default function Reports() {
//   return (
//     <div className="erp-page-grid">
//       <PageHero
//         badge="Reports center"
//         title="Reporting redesigned into a lighter export workspace."
//         subtitle="The reporting module now looks like a modern business application with clear actions, smart groupings and a more serious visual tone."
//         actions={
//           <>
//             <motion.button className="erp-btn erp-btn-ghost" whileTap={{ scale: 0.97 }}>
//               <Upload size={15} /> Load saved view
//             </motion.button>
//             <motion.button className="erp-btn erp-btn-ghost" whileTap={{ scale: 0.97 }}>
//               <FileSpreadsheet size={15} /> Excel packs
//             </motion.button>
//             <motion.button className="erp-btn erp-btn-primary" whileTap={{ scale: 0.97 }}>
//               <Download size={15} /> Export report
//             </motion.button>
//           </>
//         }
//       />

//       <StatGrid
//         items={[
//           {
//             title: "Production reports",
//             value: "28",
//             meta: "Ready to download",
//             trend: "Ready",
//             tone: "success",
//             icon: FileText,
//           },
//           {
//             title: "Loss reports",
//             value: "12",
//             meta: "Stage wise visibility",
//             trend: "Updated",
//             tone: "neutral",
//             icon: LayoutTemplate,
//           },
//           {
//             title: "Margin views",
//             value: "9",
//             meta: "Commercial dashboards",
//             trend: "Strong",
//             tone: "success",
//             icon: FileSpreadsheet,
//           },
//           {
//             title: "Saved exports",
//             value: "34",
//             meta: "Created this month",
//             trend: "+6",
//             tone: "success",
//             icon: Download,
//           },
//         ]}
//       />

//       <div className="erp-card">
//         <div className="erp-card-head">
//           <div>
//             <h3>Advanced report center</h3>
//             <p>Build downloadable packs, filter by stage, worker, size, grade, lot and date with a cleaner layout.</p>
//           </div>
//         </div>
//         <div className="erp-tile-grid">
//           {[
//             "Production report",
//             "Loss report",
//             "Worker productivity",
//             "Lot history",
//             "Approval exposure",
//             "Margin analysis",
//             "Dead stock",
//             "Target vs achievement",
//           ].map((label) => (
//             <motion.div
//               key={label}
//               className="erp-action-tile"
//               whileHover={{ y: -4 }}
//               whileTap={{ scale: 0.985 }}
//             >
//               <strong>{label}</strong>
//               <span>Open module</span>
//             </motion.div>
//           ))}
//         </div>
//       </div>

//       <div className="erp-grid erp-grid-2">
//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Export workflow</h3>
//               <p>A simpler sequence for report generation and delivery.</p>
//             </div>
//           </div>
//           <div className="erp-timeline">
//             {[
//               ["Choose pack", "Select the exact report family and saved template."],
//               ["Apply filters", "Refine by period, grade, stage, worker or agent."],
//               ["Preview", "Check totals before exporting."],
//               ["Download", "Export in business-ready format."],
//             ].map(([title, text]) => (
//               <div key={title} className="erp-timeline-item">
//                 <div className="erp-timeline-dot" />
//                 <div>
//                   <strong>{title}</strong>
//                   <p>{text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Most used packs</h3>
//               <p>Favorites surfaced in a simple visual grouping.</p>
//             </div>
//           </div>
//           <div className="erp-settings-grid">
//             {["Daily production", "Weekly loss", "Stock position", "Agent settlement", "Margin pack", "Worker productivity"].map((label) => (
//               <div key={label} className="erp-feature-chip subtle static-chip">
//                 <FileSpreadsheet size={14} />
//                 {label}
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// }




import React from "react";
import { useSearchParams } from "react-router-dom";

// 👇 pages import
import ProductionReport from "./reports/ProductionReport";
import LossReport from "./reports/LossReport";
import StockReport from "./reports/StockReport";
import WorkerReport from "./reports/WorkerReport";
import MarginReport from "./reports/MarginReport";
import DeadStockReport from "./reports/DeadStockReport";

import { Download, FileSpreadsheet, Upload } from "lucide-react";
import { motion } from "framer-motion";
import PageHero from "../components/common/PageHero";
import StatGrid from "../components/common/StatGrid";
import CompeleteStockReport from "./reports/CompeleteStockReport";
import WastageReport from "./reports/WastageReport";

export default function Reports() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");

  // 🔥 component mapping
  const componentMap = {
    production: <ProductionReport />,
    loss: <LossReport />,
    stock: <StockReport />,
    compeletestock:<CompeleteStockReport/>,
    wastagereport:<WastageReport/>,
    worker: <WorkerReport />,
    margins: <MarginReport />,
    "dead-stock": <DeadStockReport />,
  };

  if (componentMap[view]) {
    return componentMap[view];
  }

  // 👇 default dashboard
  return (
    <div className="erp-page-grid">
      <PageHero
        badge="Reports center"
        title="Reporting workspace"
        subtitle="Open different reports from below."
        actions={
          <>
            <motion.button className="erp-btn erp-btn-ghost">
              <Upload size={15} /> Load
            </motion.button>
            <motion.button className="erp-btn erp-btn-primary">
              <Download size={15} /> Export
            </motion.button>
          </>
        }
      />

      <StatGrid
        items={[
          { title: "Reports", value: "12", meta: "Available", tone: "success" },
        ]}
      />

      {/* 🔥 clickable tiles */}
      <div className="erp-tile-grid">
        {[
          { label: "Production", key: "production" },
          { label: "Loss", key: "loss" },
          { label: "Stock", key: "stock" },
          { label: "Worker", key: "worker" },
          { label: "Margins", key: "margins" },
          { label: "Dead Stock", key: "dead-stock" },
        ].map((item) => (
          <div
            key={item.key}
            className="erp-action-tile"
            onClick={() =>
              (window.location.href = `/reports?view=${item.key}`)
            }
          >
            <strong>{item.label}</strong>
            <span>Open</span>
          </div>
        ))}
      </div>
    </div>
  );
}